<template>
    <div class="bg-white p-4 shadow rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <span class="mr-2">📊</span> Faculty Count by Program
        </h2>
        <apexchart type="bar" height="300" :options="barOptions" :series="barSeries" />
    </div>
</template>

<script>
export default {
    name: "FacultyCountByProgramChart",
    props: {
        categoryCounts: {
            type: Object,
            required: true
        },
        powerBiColors: {
            type: Array,
            required: true
        }
    },
    computed: {
        barOptions() {
            return {
                chart: { toolbar: { show: false } },
                xaxis: {
                    categories: Object.keys(this.categoryCounts),
                    labels: { style: { fontSize: '12px' } },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        distributed: true, // 🟩 different color per bar
                    },
                },
                colors: this.powerBiColors.slice(0, Object.keys(this.categoryCounts).length),
                dataLabels: { enabled: true },
                legend: { show: false },
            };
        },
        barSeries() {
            return [{
                name: 'Total Faculty',
                data: Object.values(this.categoryCounts),
            }];
        }
    }
};
</script>

<style lang="scss" scoped></style>
